export default __webpack_public_path__ + "assets/_Chapters/_Images/background/VerwaltungMessmittelUndElektrowerkzeuge/1.webp";